import React from 'react';

import { COLORS } from '../../../constants';
import { useApp } from '../../../store/AppContext';
import { fmtDate } from '../../../utils/format';
import { devColorNameLookup } from '../../../utils/planning';
import PlanningBar from '../shared/PlanningBar';

/* Barres d'une phase, à la couleur de chaque membre ; l'infobulle compare planifié et consommé
   Jira de l'epic. */
export default function ProjectBars({ segs, rowKey }) {
  const { appState } = useApp();
  const { colorOf, nameOf } = devColorNameLookup(appState.devs, COLORS, '?');
  return segs.map((sg) => {
    const devName = nameOf(sg.devId);
    const hoverLines = [
      { label: devName, value: '', bold: true },
      ...(sg.brique
        ? [{ label: 'Brique', value: sg.brique }]
        : [{ label: '', value: 'Niveau client' }]),
      { label: 'Période', value: `${fmtDate(sg.realStart)} → ${fmtDate(sg.realEnd)}` },
      { label: 'Planifié', value: `${sg.totalH}h (${sg.h}h/jour)` },
      ...(sg.consoJira != null
        ? [
            {
              label: 'Consommé Jira',
              value: `${sg.consoJira}h`,
              color: sg.consoJira > sg.totalH ? '#E24B4A' : '#1D9E75',
            },
          ]
        : []),
    ];
    return (
      <PlanningBar
        key={sg.affId}
        sg={sg}
        match={{ rowKey }}
        color={colorOf(sg.devId)}
        label={sg.brique ? `${devName} · ${sg.brique}` : devName}
        hoverLines={hoverLines}
        roundedHandles
      />
    );
  });
}
